import moment from 'moment';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { BiRupee } from 'react-icons/bi';
import { Link, useParams } from 'react-router-dom';
import { getBuyerSingleTransactions } from '../../../../Redux/Payment/action';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';

const PaymentHistoryListing = () => {
    const params = useParams()

    const [startDate, setStartDate] = useState(new Date());
    const [transactions, setTransactions] = useState([]);
    useEffect(() => {
        getTransactionData(startDate)

    }, []);
    const onChangeDate = (date) => {
        setStartDate(date)
        getTransactionData(date)
    }
    const getTransactionData = (date) => {
        // let formData = new FormData();
        // formData.append('date_from', moment(date).format('YYYY-MM-DD'))
        // formData.append('date_to', moment(date).add(1, 'd').format('YYYY-MM-DD'))
        getBuyerSingleTransactions(params?.id)((response) => {
            if (response && response.status) {
                setTransactions(response?.data?.data)
            }
        });
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Payment History Listing</h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Payment History Listing</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section id="features" className="features">
                <div className="container">
                    <section className="paymenthist-buyer section-bg p-0">
                        <div className="container">
                            <div className="row">
                                {transactions?.map((transaction, index) =>
                                    <React.Fragment>
                                        <div className="col-lg-4 mb-3" key={index}>
                                            <div className="member d-flex align-items-start">
                                                <div className="member-info">
                                                    <span className="badge badge-light-primary mb-2">Transaction id : {transaction?.transaction_id}</span>
                                                    <h4>{transaction?.task_details?.title}</h4>
                                                    {transaction?.type_of_transaction == "CREDITED" ?
                                                        <p className='amount-credited fw-bold' style={{ display: "flex", alignItems: "center" }}><BiRupee size="20" style={{ color: "#000" }} />{parseFloat(transaction?.transferred_amount).toFixed(2)}</p>
                                                        :
                                                        <p className='amount-debited fw-bold' style={{ display: "flex", alignItems: "center" }}><BiRupee size="20" style={{ color: "#000" }} />{parseFloat(transaction?.transferred_amount).toFixed(2)}</p>
                                                    }
                                                    <p>Method of transaction : {transaction?.method_of_transaction}</p>
                                                    <p>Type : {transaction?.type_of_transaction}</p>
                                                    <p><i className="bi bi-calendar"></i> {moment(transaction?.created_date).format('ll')}</p>
                                                    <div className='status'>
                                                        <p>Status: </p>
                                                        {transaction?.status == 'SUCCESSFUL' ?
                                                            <span className="badge badge-light-success">Successful</span>
                                                            :
                                                            <span className="badge badge-light-warning">{transaction?.status}</span>

                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>

                        </div>
                    </section>

                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default PaymentHistoryListing;